import { type ReactElement, createContext } from 'react';

import { SliceData } from '../types/pie-chart.config.js';

interface ChartSeriesActionContextProps {
  chartSeriesActions?: (series: SliceData) => ReactElement;
}

export const SeriesActionContext = createContext<ChartSeriesActionContextProps>(
  {},
);
